import { gql } from "@apollo/client";

const NOTIFICATION_ADDED = gql`
  subscription notificationAdded($where: NotificationWhereInput) {
    notificationAdded(where: $where) {
      id
      content
    }
  }
`;

const NOTIFICATION_UPDATED = gql`
  subscription notificationUpdated($where: NotificationWhereInput) {
    notificationUpdated(where: $where) {
      id
      content
    }
  }
`;

const NOTIFICATION_DELETED = gql`
  subscription notificationDeleted($where: NotificationWhereInput) {
    notificationDeleted(where: $where) {
      id
      content
    }
  }
`;

const notifications = {
  NOTIFICATION_ADDED,
  NOTIFICATION_UPDATED,
  NOTIFICATION_DELETED,
};

export default notifications;
